import React, { useState } from'react';
import styled from '@emotion/styled';

interface HeaderPcProps {
  disable: boolean;
}
const HeaderPc:React.FC<HeaderPcProps> = ({ disable }) => {
  const handleGotoHomapage:React.MouseEventHandler<HTMLDivElement> | undefined = () => {
    window.location.href="/"
  };

  const handleGotoSubscribe = () => {
    window.location.href="/subscribe"
  };

  const handleGotoApp = () => {
    window.location.href="/app"
  };

  const handleGotoProduct = () => {
    window.location.href="/product"
  };

  const handleGotoEvent = () => {
    window.location.href="/free"
  };


  return(
    <>
      <Header>
        {/* <EvnetContainer>
        7월 한 달간, 카카오톡 친구 추가하면 사진 10장을 무료로 드립니다!
        </EvnetContainer> */}
        <MainContainer>
          <LogoImg onClick={handleGotoHomapage}>
            <ImgBox  src="/images/newLanding/home/homeicon.png"/>
          </LogoImg>
          <TapContainer>
            <LinkTap
            onClick={handleGotoSubscribe}
            >인화구독</LinkTap>
            <span style={{height: "100%"}}>|</span>
            <LinkTap
            onClick={handleGotoApp}
            >앱</LinkTap>
            <span style={{height: "100%"}}>|</span>
            <LinkTap
            onClick={handleGotoProduct}
            >앨범</LinkTap>
            {/* <span style={{height: "100%"}}>|</span>
            <LinkTap
            onClick={handleGotoEvent}
            >이벤트</LinkTap> */}
          </TapContainer>
        </MainContainer>
      </Header>
    </>
  )
};

export default HeaderPc;

const Header = styled.div`
  width: 100%;
  background-color: #ede3cd;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 2;
  /* height: 120px; */
`;
const MainContainer = styled.div`
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: row;
  align-items: end;
`

const EvnetContainer = styled.div`
  width: 100%;
  height: 30px;
  background-color: black;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
`

const LogoImg = styled.div`
  width: 80px;
  height: 80px;
  margin: 20px 0 20px 10px;
`;

const TapContainer = styled.div`
  width: 40%;
  /* width: 50%; */
  height: 20px;
  /* background-color: yellow; */
  margin: 20px 40px 30px 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
`;

const LinkTap = styled.a`
  font-size: 15px;
  color: #707070;
  &:hover{
    color: #ccc;
  }
`;

const ImgBox = styled.img`
  width: 100%;
  height: 100%;
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`